import { useMemo } from "react";
import { Heart, Sparkles } from "lucide-react";

/**
 * Subtle floating sparkles + tiny hearts in the background.
 * Tasteful, not childish (low opacity, slow motion).
 */
export default function SparkleBackground({ density = 18 }) {
  const items = useMemo(() => {
    const arr = [];
    for (let i = 0; i < density; i++) {
      arr.push({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 8,
        duration: 12 + Math.random() * 14,
        size: 10 + Math.random() * 14,
        type: Math.random() > 0.65 ? "heart" : "sparkle",
        opacity: 0.15 + Math.random() * 0.25,
      });
    }
    return arr;
  }, [density]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {items.map((it) => {
        const Icon = it.type === "heart" ? Heart : Sparkles;
        const color = it.type === "heart" ? "#d98a99" : "#d4af37";
        return (
          <div
            key={it.id}
            className="absolute bottom-[-40px]"
            style={{
              left: `${it.left}%`,
              animation: `float-up ${it.duration}s linear ${it.delay}s infinite`,
              opacity: it.opacity,
            }}
          >
            <Icon
              size={it.size}
              color={color}
              strokeWidth={1.5}
              fill={it.type === "heart" ? color : "none"}
            />
          </div>
        );
      })}
    </div>
  );
}
